<template>
    <div v-show="show" class="equipCheck-container">
       <div class="equipCheck">
        <div class="title">设备检查</div>
        <div @click="close" class="close"></div>
        <div class="notice">
            <i></i>
            <span>请确认设备和附件齐全!</span>
        </div>
        <div class="content">
            <div class="l">{{ config.type_title }}</div>
            <div class="r">
                <div class="t">
                    <div class="title">{{ config.title }}</div>
                    <ul class="list">
                        <li>
                            <div class="l">设备编号</div>
                            <div class="r">{{ config.idstring }}</div>
                        </li>
                        <li>
                            <div class="l">其他附件</div>
                            <div class="r">{{ config.other_comment }}</div>
                        </li>
                    </ul>
                </div>
                <div class="b">
                    <div class="l">留言</div>
                    <div class="r">
                        <textarea v-model="remark" maxlength="20" placeholder="请输入设备情况"></textarea>
                        <p>{{remark.length}}/20</p>
                    </div>
                </div>
            </div>
        </div>
        <div @click="confirm" class="btn">提交归还</div>
       </div>
    </div>
</template>

<script>
import common from '@common/common'
import { apis } from '@common/config'
import * as config from '@common/config'

export default {
    data() {
        return {
            remark: '',
            show: false,
            callback: null,
            config: {}
        }
    },
    methods: {
        open(config, callback) {
            console.log(config)
            this.config = config
            this.remark = '';
            this.callback = callback;
            this.show = true;
        },
        confirm() {
            this.show = false;
            if(!this.remark){
                this.remark = 'null'
            }
            this.callback(this.remark)
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        close() {
            this.cancel()
        }
    }
}
</script>

<style lang="less">
    .equipCheck-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .equipCheck {
            position: relative;
            display: flex;
            flex-direction: column;
            width: 622px;
            height: 511px;
            background: #F9F9F9;
            border-radius: 4px;
            padding: 20px 30px;
            box-sizing: border-box;

            & > .title {
                font-size: 24px;
                line-height: 33px;
                color: #050F0F;
                font-weight: 500;
                color: #050F0F;
                margin-bottom: 20px;
            }

            .close {
                position: absolute;
                top: 19px;
                right: 29px;
                display: block;
                width: 22px;
                height: 22px;
                background: url('./assets/close.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                user-select: none;
                cursor: pointer;
            }

            .notice {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 40px;
                background: #FFFAEB;
                border-radius: 4px;
                margin-bottom: 14px;

                i {
                    display: block;
                    width: 14px;
                    height: 14px;
                    background: url('./assets/notice.png') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 8px;
                }

                span {
                    font-size: 14px;
                    color: #666666;
                }
            }

            .content {
                display: flex;
                flex-direction: row;
                width: 100%;
                flex: 1;
                min-height: 0;
                background: #EFF0F0;
                border-radius: 10px;
                padding: 20px;
                box-sizing: border-box;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 4px;
                }
                &::-webkit-scrollbar-thumb {
                    background: #ddd;
                    border-radius: 4px;
                }

                & > .l {
                    width: 80px;
                    height: 45px;
                    line-height: 45px;
                    text-align: center;
                    background: rgba(65,180,140,0.1);
                    border-radius: 2px;
                    margin-right: 16px;
                    font-size: 14px;
                    color: #41B48C;
                    font-weight: bold;
                }

                & > .r {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    min-width: 0;

                    .t {
                        display: flex;
                        flex-direction: column;
                        padding: 6px 0;
                        border-bottom: 1px solid #DCDCDC;
                        box-sizing: border-box;

                        .title {
                            font-size: 14px;
                            color: #050F0F;
                            font-weight: bold;
                            margin-bottom: 10px;
                        }

                        .list {
                            display: flex;
                            flex-direction: column;

                            li {
                                display: flex;
                                margin-bottom: 10px;
                            }
                            
                            .l {
                                font-size: 14px;
                                line-height: 20px;
                                color: #829191;
                                margin-right: 20px;
                            }

                            .r {
                                font-size: 14px;
                                line-height: 20px;
                                color: #050F0F;
                            }
                        }
                    }

                    .b {
                        display: flex;
                        justify-content: space-between;
                        margin-top: 15px;

                        .l {
                            font-size: 14px;
                            line-height: 20px;
                            color: #829191;
                        }

                        .r {
                            position: relative;
                            width: 351px;
                            height: 100px;
                            background: #FFFFFF;
                            border-radius: 4px;
                            border: 1px solid #DCDCDC;
                            box-sizing: border-box;
                            overflow: hidden;

                            textarea {
                                width: 100%;
                                height: 100%;
                                resize: none;
                                padding: 10px 14px;
                                box-sizing: border-box;
                                font-size: 14px;

                                &::placeholder {
                                    color: #B9C3C3;
                                }
                            }

                            p {
                                position: absolute;
                                bottom: 7px;
                                right: 14px;
                                font-size: 14px;
                                line-height: 20px;
                                color: #B9C3C3;
                            }
                        }
                    }
                }
            }

            .btn {
                width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background: #41B48C;
                border-radius: 25px;
                margin: 20px auto 0;
                user-select: none;
                cursor: pointer;
                font-size: 14px;
                color: #FFF;
                font-weight: bold;
            }
        }
    }
</style>

<style lang="less">
.el-button--text {
    color: #41B48C !important;

    &:hover {
        color: #41B48C !important;
    }
}

.el-button.is-plain:focus, .el-button.is-plain:hover {
    color: #41B48C !important;
    border-color: #41B48C !important;
}
</style>